import createClient from "openapi-fetch";
import type { paths } from "./generated/schema";
import cookie from "cookie";

/**
 * Тип ошибки 409 при конфликте версии автозакладки.
 * Бэкенд возвращает payload.data.version, но в OpenAPI-схеме payload типизирован как unknown.
 */
export type ConflictVersionError = {
  payload?: { data?: { version?: number } };
};

function isLocalNetwork(hostname: string) {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("10.") ||
    hostname.startsWith("192.168.") ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(hostname)
  );
}

export function getClient() {
  const baseUrl = getAPIUrl();

  const client = createClient<paths>({
    baseUrl,
  });

  const clientHost =
    isLocalNetwork(window.location.hostname) ||
    window.location.hostname.includes("stage")
      ? "www.litres.ru"
      : window.location.host;

  client.use({
    onRequest: ({ request }) => {
      const cookies = cookie.parse(document.cookie || "");
      request.headers.set("App-Id", "115");
      request.headers.set("Session-Id", cookies.SID);
      request.headers.set("Client-host", clientHost);
      return request;
    },
  });

  return client;
}

function getAPIUrl() {
  const tld = window.location.hostname.match(/(?<=\.)[^.]+$/)?.[0];
  if (tld !== "io" && !isLocalNetwork(window.location.hostname)) {
    return `https://api.litres.ru/foundation`;
  }
  // localhost / LAN через Vite proxy
  if (isLocalNetwork(window.location.hostname)) {
    return "/foundation";
  }
  // devbox
  const url = new URL(window.location.href);
  url.host = `api.${url.host.replace("www.", "")}`;
  return `${url.protocol}//${url.host}/foundation`;
}

export async function getShortUserInfo() {
  try {
    const client = getClient();
    const { data } = await client.GET("/api/users/me");

    if (!data?.payload?.data) {
      console.warn("Некорректный ответ от сервера:", data);
      return null;
    }

    return data.payload.data;
  } catch (error) {
    console.error("Ошибка при получении информации о пользователе:", error);
    return null;
  }
}
